import {HTMLAttributes, ReactNode} from 'react';

export interface CaptionProps extends HTMLAttributes<HTMLDivElement> {
  type: CaptionType;
  indent?: boolean;
  label: ReactNode;
  boldDetail?: string;
  showPrefixDot?: boolean;
}

export enum CaptionType {
  Title = 'title',
  StaticTitle = 'static-title',
  Static = 'static',
  Normal = 'normal',
  NormalBold = 'normal-bold', // 피그마상엔 없지만 특정 상황에선 볼드가 필요해 추가
  Body = 'body',
}
